import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import { ModalParams } from "core/models";
import { NikoPatientTemplateService } from '../services';

class PatientTemplateCustomOrderingDoctorAddViewStore extends BaseViewStore {
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.patientTemplate = componentProps.patientTemplate;
        this.patientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);

        this.patientTemplateCustomOrderingDoctorChangeModal = new ModalParams({});
    }

    @action.bound
    async updateCustomOrderingDoctorData(action) {
        if (action === "change-doctor") {
            await this.openPatientTemplateCustomOrderingDoctorChangeModal();
        }
        else if (action === "undo-change-doctor") {
            this.patientTemplate.customOrderingDoctorId = null;
            await this.patientTemplateService.updateCustomOrderingDoctor(this.patientTemplate);
        }
        else if (action === "remove-doctor") {
            this.patientTemplate.isOrderingDoctorRemoved = true;
            await this.patientTemplateService.updateCustomOrderingDoctor(this.patientTemplate);
        }
        else if (action === "undo-remove-doctor") {
            this.patientTemplate.isOrderingDoctorRemoved = false;
            await this.patientTemplateService.updateCustomOrderingDoctor(this.patientTemplate);
        }
    }

    @action.bound
    async openPatientTemplateCustomOrderingDoctorChangeModal() {
        await this.patientTemplateCustomOrderingDoctorChangeModal.open({
            patientTemplate: this.patientTemplate,
            patientTemplateService: this.patientTemplateService
        });
    }
}

export default PatientTemplateCustomOrderingDoctorAddViewStore;
